<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__content">
        <div class="footer__logo">
          <img src="/assets/reffal-logo.png" alt="reffal" class="footer-logo-image" />
        </div>
        
        <div class="footer__section">
          <h3 class="footer__title font-inter">Read more</h3>
          <nav class="footer__links">
            <a href="#" class="footer__link font-inter">Workers comp</a>
            <a href="#" class="footer__link font-inter">Team collaboration</a>
          </nav>
        </div>
        
        <div class="footer__section">
          <h3 class="footer__title font-inter">Legals and things</h3>
          <nav class="footer__links">
            <a href="#" class="footer__link font-inter">Privacy policy</a>
            <a href="#" class="footer__link font-inter">California Privacy Notice</a>
            <a href="#" class="footer__link font-inter">Compensation Disclosure</a>
            <a href="#" class="footer__link font-inter">Terms</a>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: var(--color-gray-50);
  border-top: 1px solid var(--color-gray-200);
  padding: var(--space-12) 0 var(--space-8);
  margin-top: var(--space-16);
}

.footer__content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: var(--space-8);
}

.footer-logo-image {
  height: 30px;
  width: auto;
  display: block;
}

.footer__section {
  display: flex;
  flex-direction: column;
}

.footer__title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-gray-700);
  margin: 0 0 var(--space-4) 0;
}

.footer__links {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.footer__link {
  color: var(--color-gray-500);
  text-decoration: none;
  font-size: var(--font-size-sm);
  transition: color 0.2s ease;
}

.footer__link:hover {
  color: var(--color-primary);
}

@media (max-width: 1024px) {
  .footer__content {
    grid-template-columns: 1fr 1fr;
    gap: var(--space-8);
  }
  
  .footer__logo {
    grid-column: 1 / -1;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: var(--space-8) 0;
  }
  
  .footer__content {
    grid-template-columns: 1fr;
    gap: var(--space-6);
    text-align: center;
  }
  
  .footer__logo {
    grid-column: 1;
  }
}
</style>
